import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  initialValues,
  validationSchema,
} from "../../../componentes/Administrador_TextoRegistro";
import { useFormik } from "formik";
import { Checkbox, Segment, Header, Grid } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { estiloColores } from "../../../estilos/colores";
import { apiTexto } from "../../../api/texto";
import { apiIdioma } from "../../../api/idioma";
import Swal from "sweetalert2";
import { ENTORNO } from "../../../utils/constantes";
import { setTitulo, getrole } from "../../../utils/variablesLocales";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { TextField } from "@material-ui/core";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { Form } from "semantic-ui-react";

const apiidioma = new apiIdioma();
const apitexto = new apiTexto();

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export function TextoRegistro(props) {
  const [YaCargoComboIdioma, setYaCargoComboIdioma] = useState(0);

  setTitulo("Texto");

  ////////////////////////////////

  const [idiomas, setIdioma1] =
    useState(
      null
    ); /*esta variable idiomas, maneja el estado del item seleccionado en el combo idioma*/

  ////////////////////////////////

  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        //obtengo la lista de idiomas para luego cargar el combo
        if (YaCargoComboIdioma === 0) {
          const respuesta = await apiidioma.obtener();
          setIdioma1(respuesta);

          setYaCargoComboIdioma(1);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  const navigate = useNavigate();
  const parametro = useLocation();

  const navigateToTextoConsulta = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/TextoConsulta");
  };

  const formik = useFormik({
    initialValues: initialValues(parametro.state),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (parametro.state.accion === "editar") {
          const respuesta = await apitexto.actualizar(
            parametro.state.id,
            formik.values.tipo,
            formik.values.idioma,
            formik.values.texto,
            formik.values.activo
          );

          if (respuesta.status === 200) {
            Swal.fire({
              title: "",
              text: "Cambios registrados correctamente",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Azul,
            }).then(function () {
              navigateToTextoConsulta();
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Error al guardar cambios",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Gris,
            });
          }
        } else {
          const respuesta = await apitexto.nuevo(
            formik.values.tipo,
            formik.values.idioma,
            formik.values.texto,
            formik.values.activo
          );
          if (respuesta.status === 200) {
            Swal.fire({
              title: "",
              text: "Registro creado correctamente",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Azul,
            }).then(function () {
              navigateToTextoConsulta();
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Error al crear registro",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Gris,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  ////////////////////////////////

  var idiomaRegistros = [];

  if (idiomas) {
    for (let i = 0; i < idiomas.length; i++) {
      idiomaRegistros.push({
        key: idiomas[i].Nombre,
        text: idiomas[i].Nombre,
        value: idiomas[i].Nombre,
      });
    }
  }

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <div className="divPrincipal_ImportarNomina">
        <form onSubmit={formik.handleSubmit}>
          <React.Fragment>
            <CssBaseline />
            <AppBar style={{ background: "#DC030E" }}>
              <Toolbar>
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  onClick={navigateToTextoConsulta}
                  aria-label="menu"
                  sx={{ mr: 2 }}
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  Textos varios - Registro
                </Typography>
                <IconButton
                  size="large"
                  aria-label="display more actions"
                  edge="end"
                  color="inherit"
                  type="submit"
                >
                  <CheckIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <Toolbar id="back-to-top-anchor" />
            <Container>
              <Box sx={{ my: 2 }}>
                <Segment style={estiloSegmento.Administrador}>
                  <Grid
                    textalign="center"
                    container
                    style={{ padding: "1em 0em" }}
                  >
                    <div className="ingresar">
                      <Grid.Row>
                        <Grid.Column style={{ width: "100%" }}>
                          <Box
                            //component="form"
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              "& > :not(style)": { m: 1, width: "100%" },
                            }}
                            noValidate
                            autoComplete="off"
                          >
                            <Header as="h3">Tipo</Header>
                            <TextField
                              id="tipo"
                              placeholder="Tipo"
                              variant="standard"
                              name="tipo"
                              type="text"
                              value={formik.values.tipo}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.tipo &&
                                Boolean(formik.errors.tipo)
                              }
                              helperText={
                                formik.touched.tipo && formik.errors.tipo
                              }
                            />
                            <Header as="h3">Idioma</Header>
                            <Box sx={{ minWidth: 120 }}>
                              <FormControl fullWidth>
                                <NativeSelect
                                  value={formik.values.idioma}
                                  inputProps={{
                                    name: "idioma",
                                    id: "idioma",
                                  }}
                                  onChange={(_, data) =>
                                    formik.setFieldValue("idioma", data.value)
                                  }
                                  error={formik.errors.idioma}
                                >
                                  {/* {idiomaRegistros.map((opcion) => (
                                  <option key={opcion.value} value={opcion.value}>
                                    &nbsp;{opcion.text}
                                  </option>
                                ))} */}

                                  <option key="English" value="English">
                                    English
                                  </option>
                                  <option key="Español" value="Español">
                                    Español
                                  </option>
                                  <option key="Português" value="Português">
                                    Português
                                  </option>
                                </NativeSelect>
                              </FormControl>
                            </Box>
                          </Box>
                        </Grid.Column>
                      </Grid.Row>
                    </div>
                  </Grid>
                  <Grid textalign="center">
                    <Grid.Row textAlign="center">
                      <Grid.Column style={{ width: "100%" }}>
                        <Box
                          //component="form"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            "& > :not(style)": { m: 1, width: "100%" },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <Header as="h3">Texto</Header>
                          <TextField
                            id="filled-multiline-flexible"
                            name="texto"
                            value={formik.values.texto}
                            multiline
                            onChange={formik.handleChange}
                            error={formik.errors.texto}
                            placeholder="Texto"
                            variant="filled"
                            style={{ width: "70%" }}
                          />
                          <Form.Field>
                            <Checkbox
                              name="activo"
                              label="Activo"
                              checked={formik.values.activo}
                              onChange={() =>
                                formik.setFieldValue(
                                  "activo",
                                  !formik.values.activo
                                )
                              }
                            />
                          </Form.Field>
                          {/* <div
                          style={{
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            width: "100%",
                          }}
                        >
                          <Checkbox
                            name="activo"
                            label="Activo"
                            checked={formik.values.activo}
                            onChange={() =>
                              formik.setFieldValue(
                                "activo",
                                !formik.values.activo
                              )
                            }
                            style={{ width: "25%" }}
                          />
                        </div> */}
                        </Box>
                        <br></br>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Box>
            </Container>
            <ScrollTop {...props}>
              <Fab size="small" aria-label="scroll back to top">
                <KeyboardArrowUpIcon />
              </Fab>
            </ScrollTop>
          </React.Fragment>
        </form>
      </div>
    </div>
  );
}
